import label from './pictorialBar.data.label'
import itemStyle from './pictorialBar.data.itemStyle'
import emphasis from './pictorialBar.data.emphasis'
import tooltip from './pictorialBar.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "系列中的数据内容数组。数组项通常为具体的数据项。",
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称。",
    },
    value: {
      name: "value",
      nickname: "值",
      desc: "单个数据项的数值。",
      type: "pureValue",
    },
    symbol: {
      name: "symbol",
      nickname: "箭头",
      desc: "图形类型。",
      value: "circle",
      defaultValue: "circle",
      type: "pureValue",
    },
    symbolSize: {
      name: "symbolSize",
      nickname: "箭头大小",
      desc: "图形的大小。",
      value: ["100%", "100%"],
      defaultValue: ["100%", "100%"],
      type: "pureValue",
    },
    symbolPosition: {
      name: "symbolPosition",
      nickname: "图形的定位位置",
      desc: "图形的定位位置。可取值：",
      value: "start",
      defaultValue: "start",
      type: "pureValue",
    },
    symbolOffset: {
      name: "symbolOffset",
      nickname: "箭头偏移",
      desc:
        '图形相对于原本位置的偏移。<code class="codespan">symbolOffset</code> 是图形定位中最后计算的一个步骤，可以对图形计算出来的位置进行微调。',
      value: [0, 0],
      defaultValue: [0, 0],
      type: "pureValue",
    },
    symbolRotate: {
      name: "symbolRotate",
      nickname: "旋转角度",
      desc: "图形的旋转角度。",
    },
    symbolRepeat: {
      name: "symbolRepeat",
      nickname: "指定图形元素是否重复",
      desc: "指定图形元素是否重复。值可为：",
    },
    symbolRepeatDirection: {
      name: "symbolRepeatDirection",
      nickname: "指定图形元素重复时，绘制的顺序",
      desc: "指定图形元素重复时，绘制的顺序。这个属性在两种情况下有用处：",
      value: "start",
      defaultValue: "start",
      type: "pureValue",
    },
    symbolMargin: {
      name: "symbolMargin",
      nickname: "图形的两边间隔",
      desc:
        '图形的两边间隔（『两边』是指其数值轴方向的两边）。可以是绝对数值（如 <code class="codespan">20</code>），或者百分比值（如 <code class="codespan">&#39;-30%&#39;</code>），表示相对于自身尺寸 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-pictorialBar.symbolSize">symbolSize</a> 的百分比。只有当 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-pictorialBar.symbolRepeat">symbolRepeat</a> 被使用时有意义。',
    },
    symbolClip: {
      name: "symbolClip",
      nickname: "是否剪裁图形",
      desc: "是否剪裁图形。",
      value: false,
      defaultValue: false,
    },
    symbolBoundingData: {
      name: "symbolBoundingData",
      nickname: "指定图形界限的值",
      desc:
        '这个属性是『指定图形界限的值』。它指定了一个 data，这个 data 映射在坐标系上的位置，是图形绘制的界限。也就是说，如果设置了 <code class="codespan">symbolBoundingData</code>，图形的尺寸则由 <code class="codespan">symbolBoundingData</code> 决定。',
    },
    symbolPatternSize: {
      name: "symbolPatternSize",
      nickname: "symbolPatternSize",
      desc: "可以使用图片作为图形的 pattern。",
      value: 400,
      defaultValue: 400,
      type: "pureValue",
    },
    z: {
      name: "z",
      nickname: "z",
      desc: "指定图形元素间的覆盖关系。数值越大，越在层叠的上方。",
    },
    hoverAnimation: {
      name: "hoverAnimation",
      nickname: "是否开启 hover 在拐点标志上的提示动画效果",
      desc: "是否开启 hover 在图形上的提示动画效果。",
      value: false,
      defaultValue: false,
    },
    animation: {
      name: "animation",
      nickname: "是否使用动画",
      desc: "是否开启动画。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    animationThreshold: {
      name: "animationThreshold",
      nickname: "是否开启动画的阈值",
      desc:
        "是否开启动画的阈值，当单个系列显示的图形数量大于这个阈值时会关闭动画。",
      value: 2000,
      defaultValue: 2000,
      type: "pureValue",
    },
    animationDuration: {
      name: "animationDuration",
      nickname: "动画时长",
      desc:
        "初始动画的时长，支持回调函数，可以通过每个数据返回不同的时长实现更戏剧的初始动画效果：",
      value: 1000,
      defaultValue: 1000,
      type: "pureValue",
    },
    animationEasing: {
      name: "animationEasing",
      nickname: "初始动画缓动效果",
      desc:
        '初始动画的缓动效果。不同的缓动效果可以参考 <a href="https://echarts.apache.org/examples/zh/editor.html?c=line-easing" target="_blank">缓动示例</a>。',
      value: "cubicOut",
      defaultValue: "cubicOut",
      type: "pureValue",
    },
    animationDurationUpdate: {
      name: "animationDurationUpdate",
      nickname: "动画时长",
      desc: "数据更新动画的时长。",
      value: 300,
      defaultValue: 300,
      type: "pureValue",
    },
    animationEasingUpdate: {
      name: "animationEasingUpdate",
      nickname: "数据更新动画的缓动效",
      desc: "数据更新动画的缓动效果。",
      value: "cubicOut",
      defaultValue: "cubicOut",
      type: "pureValue",
    },
    animationDelay: {
      name: "animationDelay",
      nickname: "初始动画延迟",
      desc:
        "动画开始之前的延迟，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更戏剧的更新动画效果。",
      value: 0,
      defaultValue: 0,
    },
    animationDelayUpdate: {
      name: "animationDelayUpdate",
      nickname: "数据更新动画的延迟",
      desc:
        "数据更新动画的延迟，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更戏剧的更新动画效果。",
      value: 0,
      defaultValue: 0,
    },
    label,
    itemStyle,
    emphasis,
    tooltip,
  },
}
